import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {
  "title": "3-7",
  "description": "Yoga Sutra Chapter 3, Verse 7"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3 {...{
      "id": "-3-7--"
    }}><a parentName="h3" {...{
        "href": "/Chapter-3/3-6/"
      }}>{`<`}</a>{` 3-7 `}{` `}<a parentName="h3" {...{
        "href": "/Chapter-3/3-8/"
      }}>{`>`}</a></h3>
    <h1 {...{
      "id": "trayam-antar-aṅgaṃ-pūrvebhyaḥ"
    }}>{`trayam-antar-aṅgaṃ pūrvebhyaḥ`}</h1>
    <h4 {...{
      "id": "the-three-are-the-internal-limb-from-the-preceding"
    }}>{`The three are the internal limb from the preceding`}</h4>
    <br />
    <p><strong parentName="p">{`traya`}</strong>{` - the three`}</p>
    <p><strong parentName="p">{`antar`}</strong>{` - internal`}</p>
    <p><strong parentName="p">{`aṅga`}</strong>{` - limb`}</p>
    <p><strong parentName="p">{`pūrva`}</strong>{` - preceding`}</p>
    <br />
    <h4 {...{
      "id": "commentary-by-tkv-desikachar"
    }}>{`Commentary by TKV Desikachar:`}</h4>
    <p>{`“Pūrva Aṅga is essentially a process of elimination
in which we eliminate those thoughts that are not relevant.
In fact Yoga is the process of eliminating the undesirable
so we can be linked with the desirable.
It is the movement from Saṃyoga to Viyoga,
from Saguṇa to Nirguṇa.
But we must be careful how we define desirable or undesirable.”
– TKV Desikachar Madras December 19th 1988`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      